import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './WhatsAppIntegration.css';

const WhatsAppIntegration = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Best AI Driven Multi device and Multi-Number WhatsApp Broadcasting</title>
        <meta
          name="description"
          content="Best AI assisted Multi device WhatsApp messaging solutions for lead generation and campaign performance with comprehensive analytics and reporting."
        />
        <meta
          name="keywords"
          content="WhatsApp AI Integration, AI assisted WhatsApp messaging, AI assisted WhatsApp, WhatsApp Broadcasting, WhatsApp messaging, AI Whatsapp Assistant"
        />
        <link rel="canonical" href="https://www.aichatassist.com/platform/whatsapp-integration" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="AI assisted WhatsApp Messaging | AI Chat Assist Global"
        />
        <meta
          property="og:description"
          content="Revolutionize communication with AI Chat Assist. AI assisted WhatsApp integration for businesses in Singapore, UK & UAE to automate and scale messaging."
        />
        <meta
          property="og:url"
          content="https://www.aichatassist.com/platform/whatsapp-integration"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://admin.aichatassist.com/uploads/Wordpress_Plugin_Banner_6964048f39.jpg"
        />
        <meta property="og:site_name" content="AI Chat Assist" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="AI assisted WhatsApp Messaging | AI Chat Assist Global"
        />
        <meta
          name="twitter:description"
          content="Revolutionize communication with AI Chat Assist. AI assisted WhatsApp integration for businesses in Singapore, UK & UAE to automate and scale messaging."
        />
        <meta
          name="twitter:image"
          content="https://admin.aichatassist.com/uploads/Wordpress_Plugin_Banner_6964048f39.jpg"
        />
        <meta name="twitter:site" content="@aichatassist" />
      </Helmet>

      {/* Hero Section */}
      <section
        className="page-hero-section py-5"
        style={{
          borderRadius: '0px',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="display-3 fw-bold mb-4">
                <span className="hero-highlight">Connect</span> with{' '}
                <span className="text-gradient">WhatsApp</span>
                <br />
                <span className="text-gradient hero-highlight">AI</span>{' '}
                <span className="hero-highlight">Integration</span>
              </h1>
              <h3 className="mb-4 fw-semibold">
                AI assisted WhatsApp messaging across devices and numbers.
              </h3>
              <p className="lead text-muted mb-4">
                Automate conversations, generate leads, and analyze performance with AI Whatsapp
                Assistant. Ideal for multi-device and multi-number WhatsApp broadcasting.
              </p>
              {/* <div className="hero-stats d-flex flex-wrap mb-4">
                <div className="stat-item me-5 mb-3">
                  <h2 className="display-4 fw-bold text-dark mb-0">2B+</h2>
                  <p className="text-primary mb-0">Active Users</p>
                </div>
                <div className="stat-item me-5 mb-3">
                  <h2 className="display-4 fw-bold text-dark mb-0">24/7</h2>
                  <p className="text-primary mb-0">AI Support</p>
                </div>
                <div className="stat-item mb-3">
                  <h2 className="display-4 fw-bold text-dark mb-0">98%</h2>
                  <p className="text-primary mb-0">Open Rate</p>
                </div>
              </div>
              <div className="hero-cta mt-4 d-flex flex-wrap">
                <Link to="/contact" className="btn btn-primary btn-lg me-3 mb-2 px-4 py-3 rounded-pill">Get Started</Link>
                <a href="#how-it-works" className="btn btn-outline-primary btn-lg mb-2 px-4 py-3 rounded-pill d-flex align-items-center">
                  <span className="d-flex align-items-center justify-content-center me-2" style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: 'rgba(13, 110, 253, 0.1)' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
                      <polygon points="5 3 19 12 5 21 5 3"></polygon>
                    </svg>
                  </span>
                  See How it works
                </a>
              </div> */}
            </div>
            <div className="col-lg-6 position-relative">
              <div className="page-hero-image mt-5 mt-lg-0" style={{ position: 'relative' }}>
                <img
                  src="/images/wbsection/whatsappImg.png"
                  alt="WhatsApp Integration"
                  className=" rounded-4 w-100"
                  style={{
                    transform: 'perspective(1000px) rotateY(-5deg)',
                    transition: 'transform 0.5s ease',
                    // border: '12px solid white',
                    // borderRadius: '40px',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'perspective(1000px) rotateY(-5deg)';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Benefits Section */}
      <section
        className="benefits-section py-5"
        style={{
          borderRadius: '0px',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="section-heading text-center mb-5">
            <h2>
              Why Choose <span className="hero-highlight">AI-Powered WhatsApp</span>
            </h2>
            <p className="lead">
              Enhance customer interactions with intelligent automation on the world's most popular
              messaging platform
            </p>
          </div>

          <div className="whatsapp-benefits-container">
            <Slider
              className="whatsapp-benefits-slider"
              dots={true}
              infinite={true}
              speed={500}
              slidesToShow={4}
              slidesToScroll={1}
              autoplay={true}
              autoplaySpeed={3000}
              pauseOnHover={true}
              centerMode={true}
              centerPadding="30px"
              responsive={[
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ]}
            >
              {/* Card 1 - Global Reach */}
              <div className="whatsapp-benefit-card">
                <div className="whatsapp-benefit-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
                <h3 className="whatsapp-benefit-title">Global Reach via WhatsApp Messaging</h3>
                <p className="whatsapp-benefit-description">
                  Use WhatsApp messaging to engage 2+ billion users across 180+ countries with your
                  AI assisted WhatsApp presence.
                </p>
              </div>

              {/* Card 2 - Ecommerce */}
              <div className="whatsapp-benefit-card">
                <div className="whatsapp-benefit-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="2" y1="7" x2="22" y2="7"></line>
                    <path d="M12 17v4"></path>
                    <path d="M8 21h8"></path>
                    <circle cx="19" cy="5" r="1" fill="currentColor"></circle>
                    <circle cx="16" cy="5" r="1" fill="currentColor"></circle>
                  </svg>
                </div>
                <h3 className="whatsapp-benefit-title">Ecommerce on WhatsApp</h3>
                <p className="whatsapp-benefit-description">
                  Use AI assisted WhatsApp messaging to guide purchases, show product catalogs, and
                  close sales in-chat.
                </p>
              </div>

              {/* Card 3 - Security */}
              <div className="whatsapp-benefit-card">
                <div className="whatsapp-benefit-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  </svg>
                </div>
                <h3 className="whatsapp-benefit-title">Secure Messaging</h3>
                <p className="whatsapp-benefit-description">
                  All AI Whatsapp Assistant messages are end-to-end encrypted, keeping every
                  conversation secure and private.
                </p>
              </div>

              {/* Card 4 - Multi-Device */}
              <div className="whatsapp-benefit-card">
                <div className="whatsapp-benefit-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="8" y1="21" x2="16" y2="21"></line>
                    <line x1="12" y1="17" x2="12" y2="21"></line>
                  </svg>
                </div>
                <h3 className="whatsapp-benefit-title">AI Driven Multi-Device Support</h3>
                <p className="whatsapp-benefit-description">
                  Handle WhatsApp AI Integration across devices—chat, broadcast, and reply
                  seamlessly from a single business account.
                </p>
              </div>

              {/* Card 5 - Rich Analytics */}
              <div className="whatsapp-benefit-card">
                <div className="whatsapp-benefit-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                  </svg>
                </div>
                <h3 className="whatsapp-benefit-title">Campaign Analytics</h3>
                <p className="whatsapp-benefit-description">
                  Track WhatsApp messaging performance with detailed analytics—message delivery,
                  read rates, and engagement.
                </p>
              </div>
            </Slider>
          </div>
        </div>
      </section>

      {/* WhatsApp Broadcasting Excellence Section */}
      <section id="whatsapp-broadcasting" className="whatsapp-broadcast-section py-5">
        <div className="container">
          <div className="row mb-5 align-items-center">
            <div className="col-lg-5">
              <div className="whatsapp-broadcast-content">
                <h2 className="whatsapp-broadcast-title mb-4">
                  Smart <span className="whatsapp-highlight">WhatsApp Broadcasting</span>
                </h2>
                <p className="whatsapp-broadcast-desc mb-4">
                  Use AI assisted WhatsApp messaging to broadcast at scale. Send personalized,
                  policy-compliant messages through multi-number accounts—driven by rich analytics.
                </p>
                <ul className="whatsapp-feature-list">
                  <li className="whatsapp-feature-item">
                    <div className="whatsapp-feature-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    <span className="whatsapp-feature-text">
                      Protect your sender reputation and avoid message throttling
                    </span>
                  </li>
                  <li className="whatsapp-feature-item">
                    <div className="whatsapp-feature-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    <span className="whatsapp-feature-text">
                      Scale using multiple business numbers for higher volume
                    </span>
                  </li>
                  <li className="whatsapp-feature-item">
                    <div className="whatsapp-feature-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    <span className="whatsapp-feature-text">
                      Automated compliance for WhatsApp broadcasting policies
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="whatsapp-broadcast-grid">
                <div className="whatsapp-broadcast-cards">
                  {/* WhatsApp Broadcast Card 1 */}
                  <div className="whatsapp-broadcast-card-wrapper">
                    <div className="whatsapp-broadcast-card">
                      <div className="whatsapp-broadcast-card-header">
                        <div className="whatsapp-broadcast-card-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                            <path d="M12 8v4"></path>
                            <path d="M12 16h.01"></path>
                          </svg>
                        </div>
                        <h4 className="whatsapp-broadcast-card-title">Reputation Guard</h4>
                      </div>
                      <p className="whatsapp-broadcast-card-desc">
                        Protect your business identity with AI assisted WhatsApp systems that track
                        engagement, adjust volume, and preserve sender scores across broadcast
                        campaigns.
                      </p>
                    </div>
                  </div>

                  {/* WhatsApp Broadcast Card 2 */}
                  <div className="whatsapp-broadcast-card-wrapper">
                    <div className="whatsapp-broadcast-card">
                      <div className="whatsapp-broadcast-card-header">
                        <div className="whatsapp-broadcast-card-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                          </svg>
                        </div>
                        <h4 className="whatsapp-broadcast-card-title">Smart Scaling</h4>
                      </div>
                      <p className="whatsapp-broadcast-card-desc">
                        Use AI assisted WhatsApp messaging to ramp up from 100 to thousands of daily
                        messages across multiple numbers—safely and efficiently.
                      </p>
                    </div>
                  </div>

                  {/* WhatsApp Broadcast Card 3 */}
                  <div className="whatsapp-broadcast-card-wrapper">
                    <div className="whatsapp-broadcast-card">
                      <div className="whatsapp-broadcast-card-header">
                        <div className="whatsapp-broadcast-card-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <line x1="20" y1="8" x2="20" y2="14"></line>
                            <line x1="23" y1="11" x2="17" y2="11"></line>
                          </svg>
                        </div>
                        <h4 className="whatsapp-broadcast-card-title">Multi-Numbers</h4>
                      </div>
                      <p className="whatsapp-broadcast-card-desc">
                        Easily handle campaigns across multiple WhatsApp numbers with one dashboard.
                        Increase daily messaging limits and avoid bottlenecks.
                      </p>
                    </div>
                  </div>

                  {/* WhatsApp Broadcast Card 4 */}
                  <div className="whatsapp-broadcast-card-wrapper">
                    <div className="whatsapp-broadcast-card">
                      <div className="whatsapp-broadcast-card-header">
                        <div className="whatsapp-broadcast-card-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                          </svg>
                        </div>
                        <h4 className="whatsapp-broadcast-card-title">Auto Compliance</h4>
                      </div>
                      <p className="whatsapp-broadcast-card-desc">
                        AI handles all WhatsApp broadcasting rules—opt-ins, templates, timing—so you
                        can send at scale without risk.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Use Cases Section */}
      <section className="whatsapp-use-cases-section py-5">
        <div className="container position-relative">
          <div className="whatsapp-use-cases-header text-center mb-5">
            <h2 className="whatsapp-use-cases-title">
              AI WhatsApp <span className="hero-highlight">Use Cases</span>
            </h2>
            <p className="whatsapp-use-cases-desc">
              See how brands use WhatsApp AI Integration to streamline support, increase sales, and
              grow leads.
            </p>
          </div>

          <div className="whatsapp-use-cases-grid">
            {/* Use Case 1 - Customer Support */}
            <div className="whatsapp-use-case-item">
              <div className="whatsapp-use-case-card">
                <div className="whatsapp-use-case-image">
                  <img src="/images/wbsection/imgcard1.png" alt="Customer Support" />
                  <div className="whatsapp-use-case-overlay"></div>
                </div>
                <div className="whatsapp-use-case-content">
                  <div className="whatsapp-use-case-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                  </div>
                  <h3 className="whatsapp-use-case-title">Customer Support</h3>
                  <p className="whatsapp-use-case-desc">
                    Use AI Whatsapp Assistant to handle FAQs instantly—cutting response time and
                    freeing human agents for complex issues.
                  </p>
                </div>
              </div>
            </div>

            {/* Use Case 2 - Order Management */}
            <div className="whatsapp-use-case-item">
              <div className="whatsapp-use-case-card">
                <div className="whatsapp-use-case-image">
                  <img src="/images/wbsection/imgcard2.png" alt="Order Management" />
                  <div className="whatsapp-use-case-overlay"></div>
                </div>
                <div className="whatsapp-use-case-content">
                  <div className="whatsapp-use-case-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                      <line x1="3" y1="6" x2="21" y2="6"></line>
                      <path d="M16 10a4 4 0 0 1-8 0"></path>
                    </svg>
                  </div>
                  <h3 className="whatsapp-use-case-title">Order Management</h3>
                  <p className="whatsapp-use-case-desc">
                    Automate order updates and delivery tracking via AI assisted WhatsApp
                    messaging—fast, easy, and real-time.
                  </p>
                </div>
              </div>
            </div>

            {/* Use Case 3 - Lead Generation */}
            <div className="whatsapp-use-case-item">
              <div className="whatsapp-use-case-card">
                <div className="whatsapp-use-case-image">
                  <img src="/images/wbsection/imgcard3.png" alt="Lead Generation" />
                  <div className="whatsapp-use-case-overlay"></div>
                </div>
                <div className="whatsapp-use-case-content">
                  <div className="whatsapp-use-case-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                    </svg>
                  </div>
                  <h3 className="whatsapp-use-case-title">Lead Generation</h3>
                  <p className="whatsapp-use-case-desc">
                    Turn every chat into a lead. Run smart WhatsApp messaging flows to qualify
                    users, book calls, and follow up automatically.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Campaign Automation Connection Section */}
      <section className="whatsapp-campaign-section py-5">
        <div className="container position-relative">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="whatsapp-campaign-image">
                <img
                  src="/images/wbsection/whatsappmar.png"
                  alt="WhatsApp Campaign Automation"
                  className="rounded-4 w-100"
                  style={{
                    transform: 'perspective(1000px) rotateY(5deg)',
                    transition: 'transform 0.5s ease',
                    // boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                    borderRadius: '20px',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'perspective(1000px) rotateY(5deg)';
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="whatsapp-campaign-content">
                <h2 className="whatsapp-campaign-title">
                  Automate Marketing with{' '}
                  <span className="hero-highlight">Campaign Automation</span>
                </h2>

                <div className="whatsapp-campaign-features">
                  <div className="whatsapp-campaign-feature">
                    <div className="whatsapp-campaign-feature-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                    </div>
                    <div className="whatsapp-campaign-feature-content">
                      <h3 className="whatsapp-campaign-feature-title">Scheduled Broadcasts</h3>
                      <p className="whatsapp-campaign-feature-desc">
                        Use AI assisted WhatsApp messaging to schedule broadcasts across multiple
                        devices and numbers, delivering campaigns at peak engagement times.
                      </p>
                    </div>
                  </div>

                  <div className="whatsapp-campaign-feature">
                    <div className="whatsapp-campaign-feature-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>
                    </div>
                    <div className="whatsapp-campaign-feature-content">
                      <h3 className="whatsapp-campaign-feature-title">Audience Segmentation</h3>
                      <p className="whatsapp-campaign-feature-desc">
                        Leverage AI WhatsApp Assistant to segment audiences based on real-time
                        behavior, preferences, and campaign interaction data.
                      </p>
                    </div>
                  </div>

                  <div className="whatsapp-campaign-feature">
                    <div className="whatsapp-campaign-feature-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
                        <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
                      </svg>
                    </div>
                    <div className="whatsapp-campaign-feature-content">
                      <h3 className="whatsapp-campaign-feature-title">Automated Sequences</h3>
                      <p className="whatsapp-campaign-feature-desc">
                        Deploy automated WhatsApp sequences that intelligently follow up with leads,
                        enhancing response rates and conversions.
                      </p>
                    </div>
                  </div>

                  <div className="whatsapp-campaign-feature">
                    <div className="whatsapp-campaign-feature-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 3v18h18"></path>
                        <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                      </svg>
                    </div>
                    <div className="whatsapp-campaign-feature-content">
                      <h3 className="whatsapp-campaign-feature-title">Performance Analytics</h3>
                      <p className="whatsapp-campaign-feature-desc">
                        Track campaign effectiveness with detailed analytics and reports to optimize
                        your WhatsApp messaging strategy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhatsAppIntegration;
